import React, {useState} from "react"
import PropTypes from 'prop-types'
import 'bootstrap/dist/css/bootstrap.min.css'
import {Button}  from 'react-bootstrap'

function useInputValue(defaultValue = '') {
    const [value, setValue] = useState(defaultValue)

    return {
        bind: {
            value,
            onChange: event => setValue(event.target.value)
        },
        clear: () => setValue(''),
        value: () => value
    }

}


function AddManga({ onCreate }) {
    const input = useInputValue('')

    function submitHandler(event){
        event.preventDefault()
        if (input.value().trim) {
            onCreate(input.value())
            input.clear()
        }
    }

    return (
        <form style={{marginBottom: '1rem'}} onSubmit={submitHandler}>
            {/* <input value={value} onChange={event => setValue(event.target.value)} /> */}
            <input {...input.bind} />
            
            <Button variant="secondary" type="submit">
                Add mangas character
            </Button>
        </form>
    )
}

AddManga.propTypes ={
    onCreate: PropTypes.func.isRequired
}

export default AddManga